import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  MapaMesas,
  MapaMesasEstablecimientos,
  MapaMesasList,
} from './types/mapa-mesas.type';

@Injectable()
export class MapaMesasService {
  constructor(private _http: HttpClient) {}

  getMapaMesasEstablecimientos() {
    return this._http.get<MapaMesasEstablecimientos[]>(
      `${environment.API_URL}/MapasXEstablecimientos`
    );
  }

  getMapaMesas(codEstablecimiento: number) {
    return this._http.get<MapaMesasList[]>(
      `${environment.API_URL}/MapasXEstablecimientos/${codEstablecimiento}`
    );
  }

  getMapa(codMapa: number) {
    return this._http.get<MapaMesas>(
      `${environment.API_URL}/MapaMesas/${codMapa}`
    );
  }

  postMapa(mapa: MapaMesas) {
    return this._http.post(`${environment.API_URL}/MapaMesas`, mapa);
  }

  putMapa(codMapa: number, mapa: MapaMesas) {
    return this._http.put(`${environment.API_URL}/MapaMesas/${codMapa}`, mapa);
  }

  deleteMapa(codMapa: number) {
    return this._http.delete(`${environment.API_URL}/MapaMesas/${codMapa}`);
  }

  getMapaJson(url: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
      }),
    };

    return this._http.get<string>(url, httpOptions);
  }
}
